import React, { useEffect } from "react";
import { Form, Input, DatePicker, Button, Select } from "antd";
import moment from 'moment';
import { Localize } from "components/service";
import { DEFAULT_FILTER_FIELDS } from '../../graphic-stand-const';
import Icons from 'components/icons';

const GraphicStandFilterForm = ({
    action,
    graphicPacking,
    setCount,
    setFilters,
    setFilterList,
    filterList,
    gqlBuilderWhere,
    graphicStandsFilters,
    excludeFields = [],
    filterTable,
    form
}) => {

    // Initialize filterList from saved filters on component mount
    useEffect(() => {
        if (graphicStandsFilters && Object.keys(filterList).length === 0) {
            setFilterList(graphicStandsFilters);
        }
    }, [graphicStandsFilters, filterList, setFilterList]);

    const initialDate = (date, fieldName) => {
        if (date && date[ fieldName ] && date[ fieldName ].value)
        {
            return moment(date[ fieldName ].value);
        }
        return undefined;
    }

    const initialValFormatted = (date, fieldName) => {
        const val = date?.[ fieldName ]?.value;
        if (val) return val.replace(/[^a-z0-9]/gi, '');
    }

    const onChangeSetFilter = (e, name, value) => {
        if (e)
        {
            name = e.target.name
            value = e.target.value
        }

        if (name === 'EXHIBITOR' || name === 'BLOCK' || name === 'STAND_NUMBER' || name === 'HALL_NAME' || name === 'EXHIBITION_EVENT')
        {
            if (name === 'EXHIBITION_EVENT') {
                // Special handling for exhibition event - uses whereEvents with TITLE column
                value.toString().length > 0 ?
                    setFilterList({
                        ...filterList,
                        [ name ]: {
                            column: "TITLE",
                            operator: "LIKE",
                            value: `%${ value }%`
                        }
                    }) : setFilterList({ ...filterList, [ name ]: {} });
            } else {
                value.toString().length > 0 ?
                    setFilterList({
                        ...filterList,
                        [ name ]: {
                            column: name,
                            operator: "LIKE",
                            value: `${ value }%`
                        }
                    }) : setFilterList({ ...filterList, [ name ]: {} });
            }
        } else
        {
            value.toString().length > 0 ?
                setFilterList({
                    ...filterList,
                    [ name ]: {
                        column: name,
                        operator: "EQ",
                        value: value
                    }
                }) : setFilterList({ ...filterList, [ name ]: {} });
        }
    }

    const renderField = (fieldName) => {
        if (excludeFields.includes(fieldName)) return null;

        switch (fieldName)
        {
            case 'EXHIBITOR':
                return (
                    <Form.Item
                        key={ fieldName }
                        initialValue={ initialValFormatted(graphicStandsFilters, fieldName) }
                        name={ fieldName }
                        label={ <Localize>FORMS.Input_Label_Exhibitor</Localize> }
                        onChange={ onChangeSetFilter }>
                        <Input name={ fieldName } placeholder={ Localize({ children: "FORMS.Input_Placeholder_Exhibitor" }).props.children } />
                    </Form.Item>
                );
            case 'EXHIBITION_EVENT':
                return (
                    <Form.Item
                        key={ fieldName }
                        initialValue={ initialValFormatted(graphicStandsFilters, fieldName) }
                        name={ fieldName }
                        label={ <Localize>FORMS.Input_Label_ExhibitionEvent</Localize> }
                        onChange={ onChangeSetFilter }>
                        <Input name={ fieldName } placeholder={ Localize({ children: "FORMS.Input_Placeholder_ExhibitionEvent" }).props.children } />
                    </Form.Item>
                );
            case 'BLOCK':
                return (
                    <Form.Item
                        key={ fieldName }
                        initialValue={ initialValFormatted(graphicStandsFilters, fieldName) }
                        name={ fieldName }
                        label={ <Localize>FORMS.Input_Label_Block</Localize> }
                        onChange={ onChangeSetFilter }>
                        <Input name={ fieldName } placeholder={ Localize({ children: "FORMS.Input_Placeholder_BlockNumber" }).props.children } />
                    </Form.Item>
                );
            case 'STAND_NUMBER':
                return (
                    <Form.Item
                        key={ fieldName }
                        initialValue={ initialValFormatted(graphicStandsFilters, fieldName) }
                        name={ fieldName }
                        label={ <Localize>FORMS.Input_Label_StandNumber</Localize> }
                        onChange={ onChangeSetFilter }>
                        <Input name={ fieldName } placeholder={ Localize({ children: "FORMS.Input_Placeholder_StandNumber" }).props.children } />
                    </Form.Item>
                );
            case 'HALL_NAME':
                return (
                    <Form.Item
                        key={ fieldName }
                        initialValue={ initialValFormatted(graphicStandsFilters, fieldName) }
                        name={ fieldName }
                        label={ <Localize>FORMS.Input_Label_HallName</Localize> }
                        onChange={ onChangeSetFilter }>
                        <Input name={ fieldName } placeholder={ Localize({ children: "FORMS.Input_Placeholder_HallName" }).props.children } />
                    </Form.Item>
                );
            case 'STATUS':
                return (
                    <Form.Item
                        key={ fieldName }
                        initialValue={ initialValFormatted(graphicStandsFilters, fieldName) }
                        name={ fieldName }
                        label={ <Localize>FORMS.Input_Label_Status</Localize> }>
                        <Select
                            name={ fieldName }
                            placeholder={ Localize({ children: "FORMS.Input_Placeholder_ChooseStatus" }).props.children }
                            suffixIcon={ <Icons.Arrow /> }
                            onChange={ (value) => onChangeSetFilter(null, fieldName, value) }>
                            <Select.Option value="open"><Localize>FORMS.Select_OptionLabel_InProgress</Localize></Select.Option>
                            <Select.Option value="done"><Localize>FORMS.Select_OptionLabel_Completed</Localize></Select.Option>
                        </Select>
                    </Form.Item>
                );

            case 'COMPLETE_AT':
                return (
                    <Form.Item
                        initialValue={ initialDate(graphicStandsFilters, 'complete_at') }
                        name="COMPLETE_AT"
                        label={ <Localize>FORMS.Input_Label_CompletedAt</Localize> }
                    >
                        <DatePicker
                            format="DD.MM.YYYY"
                            style={ { width: '100%' } }
                            placeholder={ Localize({ children: "FORMS.Input_Placeholder_CompletedAt" }).props.children }
                            onChange={ (date, dateString) =>
                                date ?
                                    setFilterList({
                                        ...filterList,
                                        complete_at: {
                                            column: "COMPLETE_AT",
                                            operator: "LIKE",
                                            value: date.format('YYYY-MM-DD') + '%'
                                        }
                                    }) : setFilterList({
                                        ...filterList,
                                        complete_at: {}
                                    }) }
                        />
                    </Form.Item>
                );
            default:
                return null;
        }
    };

    return (
        <div className="ant-form ant-form-vertical filters-form">
            { DEFAULT_FILTER_FIELDS.map(fieldName => renderField(fieldName)) }

            <div className="form-btn-holder">
                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={ () => {
                        setFilters(gqlBuilderWhere({ ...graphicStandsFilters, ...filterList }));
                        setCount({ ...graphicStandsFilters, ...filterList });
                        action();
                    } }
                >
                    <Localize>FORMS.Button_Text_ApplyFilters</Localize>
                </Button>
                <Button
                    className="ant-btn-secondary bg-light-gray btn-right"
                    htmlType="submit"
                    onClick={ () => {
                        setFilterList({});
                        setCount({});
                        setFilters(gqlBuilderWhere({}));

                        // Handle different localStorage key patterns
                        if (graphicPacking?.id) {
                            localStorage.removeItem(`graphicStandsFilters-${ filterTable }_graphicPackingID-${ graphicPacking.id }`);
                        } else {
                            localStorage.removeItem(`graphicWarehouseFilters-${ filterTable }`);
                        }
                    } }
                >
                    <Localize>FORMS.Button_Text_ResetFilters</Localize>
                </Button>
            </div>
        </div>
    )
}

export default GraphicStandFilterForm;